// #MODULE - CaptureTiming
// > Author: Myank Raj
// >
// > Create Date: <February 1, 2017>
// >
// ##DESCRIPTION: Capture JS Timing Data to send to RASM API
// >

import $ from 'jquery';
import _ from 'underscore';
import Globals from '@component/common/src/util/Globals';
import Logger from '@component/common/src/util/Logger';

const prodUrl = '//metrics.macys.net/1x1.gif';
const devUrl = '//metrics-dev.macys.net/1x1.gif';
const { host } = window.location;
let logging = false;

const log = (opts) => { // consolidate log messages
  Logger.log(`${opts.name} start time : ${opts.timeStart} milliseconds `);
  Logger.log(`${opts.name} stop time : ${opts.timeEnd} milliseconds `);
  // total time measurement
  Logger.log(`${opts.name} total load time : ${opts.timeEnd - opts.timeStart} milliseconds `);
};

const saveTimeData = (_dataObj) => {
  const timingCaptureDataModel = {
    // Default Data Model
    appName: 'JSTimingAPIAppNameDefault',
    name: 'CaptureTiming',
    description: '',
    timeStart: '',
    timeEnd: '',
    url: window.location.href,
    page_type: $('type:last').html(),
    page_layout: $('layout:last').html(),
    server: $('server:last').html(),
    release: $('release:last').html(),
    ts: $('timestamp:last').html(),
  };
  const dataObj = _dataObj;
  logging = !!(dataObj.logging); // logging is to log messages default:false
  delete dataObj.logging; // we don't want to send log property in request
  _.extend(timingCaptureDataModel, dataObj);
  const urlContent = `?msg=${window.encodeURIComponent(JSON.stringify(timingCaptureDataModel))}`;
  /* istanbul ignore next */
  if (Globals && Globals.getValue('props.spoCaptureTimingEnabled') === 'true') {
    if (host.indexOf('.fds.com') !== -1) { // condition to fire on dev server
      $.ajax({
        type: 'GET', url: devUrl + urlContent,
      });
    } else if (_.random(0, 5) === 1) { // condition to fire on production.
      // we dont want request to be fired all the time by using random
      $.ajax({
        type: 'GET', url: prodUrl + urlContent,
      });
    }
  }
  if (logging) {
    log(dataObj);
  }
};

export default {
  saveTimeData,
  log,
};
